export const SITE_TITLE = 'Paketbox Admin';
export const LOCALE_URL = ['production', 'test'].includes(process.env.NODE_ENV)
  ? '/locales'
  : 'http://localhost:3333/locales';

export const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3333/api';
export const LOG_MISSING_TRANSLATIONS = !['production', 'test'].includes(process.env.NODE_ENV);

export const GOOGLE_MAP_API_KEY = 'AIzaSyCE_hqyzF4Zm4T3py8ieljazaeyiwa678A';

export const AUTH_ACTION_ENUMS = [];

export const ACTION_ENUMS = [
  'UNCONFIGURE',
  'FORCE_OPEN',
  'UNLOCK',
  'LOCK_AFTER_PIN_UNLOCK',
  'LOCK_AFTER_BUTTON_OPEN',
  'LOCK_AFTER_BLE_COMMAND',
  'LOCK_AFTER_BLE_PIN_UNLOCK',
  'LOCK_WITH_PIN',
  'ILLEGAL_BUTTON_ACCESS',
  'NO_ACTION',
  'CANCEL_PICK_AT_HOME',
  'CANCEL_PICK_AT_FRIEND',
  'CANCEL_SHARED',
  'MASTER_PIN_OPEN',
  'DEVICE_POWERED_UP'
];

export const PACKETBOX_STATE_ENUMS = [
  'LOCKED_AFTER_BLE_COMMAND',
  'PKB_LOCKED_AFTER_BUTTON_OPEN',
  'PIN_LOCKED',
  'UNLOCKED',
  'UNCONFIGURED',
];

export const ACCOUNT_ROLE_ENUMS = ['ADMIN', 'SUPER_ADMIN'];

export const EVENT_SOURCE_ENUMS = ['APP', 'LORA'];

export const EVENT_STATUS_ENUMS = [
  'SUCCESS',
  //  'FAIL_KEY_INVALID',
  'FAIL_OTHER',
];

export const ERRORS = {
  100: 'REQUEST_MISSING_REQUIRED_FIELDS',
  101: 'REQUEST_INVALID_VALUE',
  110: 'REQUEST_UNAUTHORIZED',
  120: 'REQUEST_UPLOAD_ERROR',
  121: 'REQUEST_DOWNLOAD_ERROR',
  1101: 'DATA_ACCOUNT_USERNAME_DUPLICATE',
  1102: 'DATA_ACCOUNT_USERNAME_INVALID',
  1103: 'DATA_ACCOUNT_PASSWORD_INVALID',
  1200: 'DATA_ENDUSER_NOTFOUND',
  1201: 'DATA_ENDUSER_USERNAME_REQUIRED',
  1202: 'DATA_ENDUSER_USERNAME_INVALID',
  1203: 'DATA_ENDUSER_USERNAME_DUPLICATE',
  1204: 'DATA_ENDUSER_EMAIL_DUPLICATE',
  1205: 'DATA_ENDUSER_EMAIL_REQUIRED',
  1206: 'DATA_ENDUSER_PASSWORD_REQUIRED',
  1207: 'DATA_ENDUSER_PASSWORD_INVALID',
  1208: 'DATA_ENDUSER_FIRSTNAME_REQUIRED',
  1209: 'DATA_ENDUSER_LASTNAME_REQUIRED',
  1210: 'DATA_ENDUSER_LANGUAGE_REQUIRED',
  1211: 'DATA_ENDUSER_REGISTER_ID_NOT_REQUIRED',
  1212: 'DATA_ENDUSER_NOTIFICATION_OPTIONS_INVALID',
  1300: 'DATA_PAKETBOX_NOTFOUND',
  1301: 'DATA_PAKETBOX_DUPLICATE',
  1302: 'DATA_PAKETBOX_PIN_INVALID',
  1303: 'DATA_PAKETBOX_CODE_INVALID',
  1304: 'DATA_PAKETBOX_OWNER_UNAUTHORIZED',
  1400: 'DATA_PAKETBOXKEY_NOTFOUND',
  1401: 'DATA_PAKETBOXKEY_INVALID',
  1402: 'DATA_PAKETBOXKEY_INVALID_EXPIRED',
  1403: 'DATA_PAKETBOXKEY_PAKETBOX_INCORRECT',
  1404: 'DATA_PAKETBOXKEY_MAXLOCK_LIMIT',
  1405: 'DATA_PAKETBOXKEY_MAXUNLOCK_LIMIT',
  1500: 'DATA_PAKETBOXLORA_NOTFOUND',
  1501: 'DATA_PAKETBOXLORA_UNAVAILABLE',
  1502: 'DATA_PAKETBOXLORA_EDIT_NOT_ALLOWED_ASSIGNED',
  9998: 'RESOURCE_UNAVAILABLE',
  9999: 'GENERIC',
};



// WEBPACK FOOTER //
// ./src/config.js